import React from 'react';
import { connect } from '../../../../redux/store';
import {
  ErrorMessage,
  EmptyMessage,
  LoadingMessage,
  StaticTypeahead,
  C,
} from '@kineticdata/bundle-common';
import { I18n } from '@kineticdata/react';
import { DefaultActions } from './';
import { CONTENT_MANAGER_MODE } from '../helpers';
import { AppendixCard } from '../../AppendixCard';
import { Map } from 'immutable';

const mapStateToProps = (state, props) => {
  const isPublicMode = props.mode === CONTENT_MANAGER_MODE.PUBLIC;
  const isViewMode = props.mode !== CONTENT_MANAGER_MODE.EDIT;
  const id = props.activeItem && props.activeItem.id;
  const appendixIds = props.values.get(C.FIELD_APPENDIX_ID, []);
  const appendices = !isPublicMode
    ? state.settingsAppendix.dataList
    : state.app.catalog.appendices;
  const relatedAppendices = appendices.filter(appendix =>
    appendixIds.includes(appendix.values[C.FIELD_APPENDIX_ID]),
  );

  return {
    isPublicMode,
    isViewMode,
    id,
    appendices,
    relatedAppendices,
    appendicesLoading: !isPublicMode
      ? !state.settingsAppendix.dataInit && state.settingsAppendix.dataLoading
      : !state.app.catalog.init && state.app.catalog.loading,
    appendicesError: !isPublicMode
      ? state.settingsAppendix.error
      : state.app.catalog.errors.first(),
    appendicesNameMap: appendices.reduce(
      (map, p) => map.set(p.values[C.FIELD_APPENDIX_ID], p.values['Name']),
      Map(),
    ),
  };
};

const ServiceAppendicesRenderer = connect(mapStateToProps)(
  ({
    mode,
    isPublicMode,
    isViewMode,
    content,
    values,
    activeItem,
    id,
    appendices,
    relatedAppendices,
    appendicesLoading,
    appendicesError,
    appendicesNameMap,
    ...props
  }) => {
    return !!activeItem ? (
      <>
        <h2>
          <I18n>{activeItem.title}</I18n>
        </h2>

        {!isViewMode && (
          <div className="form mb-3">
            <div className="form-group">
              <label htmlFor="title">
                <I18n>Section Title</I18n>
              </label>
              <input
                type="text"
                id="title"
                value={activeItem.title}
                onChange={props.handleContentChange(id, 'title')}
              />
            </div>

            <div className="form-group">
              <label htmlFor="service-appendices" className="field-label">
                <I18n>Appendices</I18n>
                <small className="d-block">
                  <I18n>Which appendices are related to this service?</I18n>
                </small>
              </label>
              <StaticTypeahead
                valueProp="id"
                labelProp="name"
                options={appendices.toJS().map(p => ({
                  id: p.values[C.FIELD_APPENDIX_ID],
                  name: p.values['Name'],
                }))}
                value={values
                  .get(C.FIELD_APPENDIX_ID, [])
                  .map(id => ({ id, name: appendicesNameMap.get(id) }))}
                onChange={vals =>
                  props.handleValuesChangeDirect(id, C.FIELD_APPENDIX_ID)(
                    vals.toJS().map(kw => kw.id),
                  )
                }
                search={{ fields: [{ name: 'name', operator: 'matches' }] }}
                multiple={true}
                minSearchLength={0}
                id="service-appendices"
              />
            </div>
          </div>
        )}

        {appendicesError ? (
          <ErrorMessage
            title="The service offerings failed to load."
            message={appendicesError.message}
          />
        ) : appendicesLoading ? (
          <LoadingMessage />
        ) : relatedAppendices.size === 0 ? (
          <EmptyMessage title="There are no appendices related to this service." />
        ) : (
          <div className="cards">
            {relatedAppendices.map(appendix => (
              <AppendixCard
                key={appendix.id}
                appendix={appendix}
                path={
                  isViewMode
                    ? `appendices/${appendix.values[C.FIELD_APPENDIX_ID]}`
                    : undefined
                }
                hideFavorite={!isPublicMode}
              />
            ))}
          </div>
        )}

        {!isViewMode && (
          <DefaultActions
            id={id}
            isDirty={activeItem.isDirty}
            handleResetSection={props.handleResetSection}
            handleContentDelete={props.handleContentDelete}
            actionsPending={props.actionsPending}
          />
        )}
      </>
    ) : null;
  },
);

// Metadata for this renderer
ServiceAppendicesRenderer.ID = 'SERVICE_APPENDICES';
ServiceAppendicesRenderer.NAME = 'Service Appendices';
ServiceAppendicesRenderer.TYPES = ['Service'];

// Define fields managed by this section so we can know which fields to reset
// when the section is reset. Can store additional metadata for fields to use in
// the renderer above.
ServiceAppendicesRenderer.FIELDS = {
  [C.FIELD_APPENDIX_ID]: {},
};

export default ServiceAppendicesRenderer;
